const Sliders = () => {
	const mainGallery = document.querySelector(".single-machine__gallery-main");
	const thumbsGallery = document.querySelector(".single-machine__gallery-thumbs");

	if (mainGallery && thumbsGallery) {
		const main = new Splide(mainGallery, {
			type: "fade",
			pagination: false,
			arrows: false,
			cover: false,
		});

		const thumbs = new Splide(thumbsGallery, {
            perPage: 4,
			gap: 12,
			rewind: true,
			pagination: false,
			arrows: false,
			isNavigation: true,
			breakpoints: {
				768: {
                    perPage: 3,
				},
                575: {
                    perPage: 2,
                }
			},
		});

		main.sync(thumbs);
		main.mount();
		thumbs.mount();
	}
};

export default Sliders;
